import React, { useState, useRef, useEffect } from "react";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import axios from "../api/axios";
import { Fieldset } from "primereact/fieldset";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Timeline } from "primereact/timeline";
import { axiosPrivate } from "../api/axios";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";

const pasosSUA = [
  {
    status: "1",
    date: "Seleccione el archivo .SUA que desea cargar al bimestre.",
  },
  {
    status: "2",
    date: "La carga del archivo iniciara de manera automatica.",
  },
  {
    status: "3",
    date: "El finalizar la carga de clic en siguiente.",
  },
];
const pasosTXT = [
  {
    status: "1",
    date: "Seleccione el archivo Aseg.txt de la EBA que desea cargar al bimestre.",
  },
  {
    status: "2",
    date: "La carga del archivo iniciara de manera automatica.",
  },
  {
    status: "3",
    date: "El finalizar la carga de clic en siguiente.",
  },
];

const ConfrontaV2 = ({Auth}) => {
  const toast = useRef(null);
  const stepperRef = useRef(null);
  const [excelURL, setExcelURL] = useState(null); // para guardar el enlace de descarga
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedBimestre, setSelectedBimestre] = useState(null);
  const [opciones, setOpciones] = useState([]);
  const [selectedEmpresa, setSeleccionado] = useState(null);
  const [suaCargado, setSuaCargado] = useState(false);
  const [txtCargado, setTxtCargado] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [resultados, setResuldado] = useState(null);
    const dt = useRef(null);
  
  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        //const Authentication=[];
        const datosTransformados =Auth.Empresas.map((item) => ({
          label: item.nombre,
          value: item.rfc,
        }));
        setOpciones(datosTransformados);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };
    fetchEmpresas();
  }, []);

  const years = [{ name: "2025", code: "2025" },{ name: "2026", code: "2026" }];

  const bimestres = [
    { name: "01", code: "01" },
    { name: "02", code: "02" },
    { name: "03", code: "03" },
    { name: "04", code: "04" },
    { name: "05", code: "05" },
    { name: "06", code: "06" },
  ];
  const ValidarForm = () => {
    if (selectedEmpresa === null) {
      showMessage("error", "Error", "Seleccione la empresa.");
      return false;
    }
    if (selectedYear === null) {
      showMessage("error", "Error", "Seleccione el año.");
      return false;
    }
    if (selectedBimestre === null) {
      showMessage("error", "Error", "Seleccione el bimestre.");
      return false;
    }
    return true;
  };
  const showMessage = (tipo, titulo, msg) => {
    toast.current.show({ severity: tipo, summary: titulo, detail: msg });
  };
  const uploadSUA = async ({ files }) => {
    if (ValidarForm() === false) {
      return;
    }
    const suaFile = files[0];

    const formData = new FormData();
    formData.append("archivo", suaFile);
    formData.append("year", selectedYear.code);
    formData.append("bimestre", selectedBimestre.code);
    formData.append("rfc", selectedEmpresa);
    setIsUploading(true);
    try {
      const response = await axios.post("SUA/uploadSUA", formData);
      showMessage("info", "Completado", response.data.message);
      setSuaCargado(true);
    } catch (error) {
      showMessage("error", "Error", error.error);
      setSuaCargado(false);
    } finally {
      setIsUploading(false);
    }
  };
  const uploadTXT = async ({ files }) => {
    if (ValidarForm() === false) {
      return;
    }
    const txtFile = files[0];
    const formData = new FormData();
    formData.append("txtFile", txtFile);
    formData.append("year", selectedYear.code);
    formData.append("bimestre", selectedBimestre.code);
    formData.append("rfc", selectedEmpresa);
    setIsUploading(true);

    try {
      const response = await axios.post("SUA/uploadTXT", formData);
      showMessage("info", "Completado", response.data.message);
      setTxtCargado(true);
    } catch (error) {
      showMessage("error", "Error", error.error);
      setTxtCargado(false);
    }
    finally {
      setIsUploading(false);
    }
  };

  const onSelect = async (event) => {
    if (ValidarForm() === false) {
      return;
    }
    setIsUploading(true);
    try {
      const response = await axiosPrivate.get("SUA/resultExcel", {
        params: {
          year: selectedYear.code,
          bimestre: selectedBimestre.code,
          rfc: selectedEmpresa,
        },
        responseType: "blob",
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        setExcelURL(downloadUrl);
        showMessage("info","Excel listo para descargar","Haz clic en el enlace.");
        stepperRef.current.nextCallback();
      }
    } catch (error) {
      showMessage("error","Error",error.error);
    } finally {
      setIsUploading(false);
    }
    
  };
    const onSelectBimestre = async (event) => {
      try {

        console.log(event);
      const response = await axios.post("SUA/ConfrontaV2", {
        params: {
          year: selectedYear.code,
          bimestre: event.code,
          rfc: selectedEmpresa,
        },
        //responseType: "blob",
      });

        // const response = await axios.get("SUA/resultData", {
        //   params: { rfc: event },
        // });
  
        if (response.status === 200) {
          const data = response.data;
          //console.table(data.coincidenciasProcesadas);
          setResuldado(data.coincidenciasProcesadas);
        }
      } catch (error) {
        console.error("Error al obtener datos:", error);
        showMessage("error", "Error", error.error);
      } finally {
      }
    };
    const rightToolbarTemplate = () => {
        return <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />;
    };
const exportCSV = () => {
        //dt.current.exportCSV();
        if (ValidarForm() === false) {
      return;
    }
        let baseURL = window.location.origin;
        console.log(baseURL);
        baseURL = baseURL.replace("3000", "3500").replace("sua.", "api.");
        const url = `${baseURL}/SUA/resultConfrontaV2?year=${selectedYear.code}&bimestre=${selectedBimestre.code}&rfc=${selectedEmpresa}`;
        window.open(url, "_blank");
    };
  return (
    <>
      {/* <Navbar Authentication={Authentication} /> */}
      <h1>Confronta V2</h1>
      <Toast ref={toast}></Toast>
      
      <div className="card flex justify-content-center">
        <div className="flex flex-column gap-2 mr-2">
          <label htmlFor="empresa">Empresa</label>
          <Dropdown
            id="empresa"
            value={selectedEmpresa}
            options={opciones}
            onChange={(e) => setSeleccionado(e.value)}
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione la empresa"
            className="w-full md:w-25rem"
          />
        </div>
        <div className="flex flex-column gap-2  mr-2">
          <label htmlFor="username">Año</label>
          <Dropdown
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.value)}
            options={years}
            optionLabel="name"
            placeholder="Seleccione el año"
            className="w-full md:w-16rem"
          />
        </div>
        <div className="flex flex-column gap-2  mr-2">
          <label htmlFor="username">Bimestre</label>
          <Dropdown
            value={selectedBimestre}
            onChange={(e) => {
              setSelectedBimestre(e.value);
              onSelectBimestre(e.value);
            }}
            options={bimestres}
            optionLabel="name"
            placeholder="Seleccione el bimestre"
            className="w-full md:w-16rem"
          />
          <small id="username-help"></small>
        </div>
      </div>
      <div className="card">
        <Toolbar className="mb-4"  right={rightToolbarTemplate}></Toolbar>
        <DataTable
                  ref={dt}
                  value={resultados}
                 // selection={selectedResultados}
                  //onSelectionChange={(e) => setSelectedEmpresas(e.value)}
                 // dataKey="_id"
                  paginator
                  rows={10}
                  selectionMode="single"
                  rowsPerPageOptions={[10, 20, 50]}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
                  //globalFilter={globalFilter}
                  //header={header}
                  // stripedRows
                >
                  <Column
                              field="NSS"
                              header="NSS"
                              sortable
                            ></Column>
                            <Column
                              field="Nombre del trabajador"
                              header="Nombre del trabajador"
                              sortable
                            ></Column>
                            <Column
                              field="Número de crédito"
                              header="Número de crédito"
                              sortable
                            ></Column>
                            <Column
                              field="Primer descuento"
                              header="Primer descuento"
                              sortable
                            ></Column>
                            <Column
                              field="SDI"
                              header="SDI"
                              sortable
                            ></Column>
                            <Column
                              field="Días bimestre"
                              header="Días bimestre"
                              sortable
                            ></Column>
                            <Column
                              field="Valor"
                              header="Valor"
                              sortable
                            ></Column>
                            <Column
                              field="Amortizacion"
                              header="Amortizacion"
                              sortable
                            ></Column>
                            <Column
                              field="Subtotal INFONAVIT"
                              header="Subtotal INFONAVIT"
                              sortable
                            ></Column>
                            <Column
                              field="Valor bimestre"
                              header="Valor bimestre"
                              sortable
                            ></Column>
                            <Column
                              field="Diferencia"
                              header="Diferencia"
                              sortable
                            ></Column>
                            <Column
                              //body={actionBodyTemplate}
                              exportable={false}
                              style={{ minWidth: "12rem" }}
                            ></Column>
                </DataTable>
      </div>
    </>
  );
};
export default ConfrontaV2;
